module.exports = __webpack_public_path__ + "static/media/init-state.fcea05be.svg";